import React from 'react';
import debounce from 'lodash.debounce';
import { SearchClient } from 'instantsearch.js';
import {
  Configure,
  InstantSearch,
  UseSearchBoxProps
} from 'react-instantsearch';

import { useSearchListContext } from '../context/SearchListProvider';
import SearchListResults from './SearchListResults';
import NoResultsBoundary from './NoResultsBoundary';
import Autocomplete from './Autocomplete';
import SearchFilter from './SearchFilter';
import CurrentRefinements from './CurrentRefinements';

export type SearchListProps = {
  searchClient: SearchClient;
  indexName?: string;
};

const DEBOUNCE_MS = 500;

const queryHook: UseSearchBoxProps['queryHook'] = debounce(
  (query, search) => search(query),
  DEBOUNCE_MS
);

const SearchList = ({
  searchClient,
  indexName = 'khs_competence_articles_index'
}: SearchListProps) => {
  const { search, hideResults } = useSearchListContext();

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={indexName}
      routing={true}
      onStateChange={(helper) => {
        if (search.resultsHidden) {
          hideResults(!helper.uiState[indexName].query);
        }
        helper.setUiState(helper.uiState);
      }}
    >
      <Configure analytics={false} filters={search.filters} />
      <div className="search-list__form grid-inner">
        <Autocomplete queryHook={queryHook} />
        <CurrentRefinements />
        <SearchFilter />
      </div>
      <NoResultsBoundary fallback={<div className="search-list__no-results" />}>
        <SearchListResults />
      </NoResultsBoundary>
    </InstantSearch>
  );
};

export default SearchList;
